module.exports = __webpack_public_path__ + "img/choose.80ab1406.png";